module.exports = ".br-sideleft .menu-item-label,\n.br-sideleft .nav-link {\n  white-space: normal;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n}\n"